import { createEvent } from "@cobuildlab/react-simple-state";
import { Representant } from "../../shared/types";

export const OnFetchRepresentants = createEvent<Representant[]>();
export const OnFetchRepresentantsError = createEvent();
